export default "__VITE_ASSET__Bd7iOPsV__"